import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../design-system/lib/IconProvider';
import { ADD_CUSTOMER, adsigne, CALL, CLOSE_DARK, CUSTOMER_TYPE, double_top, DRIVER, DRIVER_1, DRIVER_COLOR, EDIT, GROUP_1925, hashtag2, INFO_CIRCLE, list_gray, PERSON, PROFILE, STAR, WALLET } from '../../../assets';
import Typography from '../../../design-system/lib/Typography';
import Success_list from '../../../assets/Success_list.svg';

import { useTranslation } from 'react-i18next';
import Switch from '../../../design-system/lib/Switch';
import DropDown from '../../../design-system/lib/DropDown';
import { useDispatch, useSelector } from 'react-redux';
import { Add_Driver_Option, Remove_Driver_Option, Set_Auto_ActiveVehicleType, Set_Auto_Driver, Set_Force_Assaigning, Set_Manual_ActiveVehicleType, Update_Driver_ManualEta } from '../../../Redux/actions/actionNames';
import Button from '../../../design-system/lib/Button';
import SearchList from '../../../design-system/lib/SearchList';
import { GetVehicletypeByServiceAction, SearchDriverAction, Voip_OutgoingCall } from '../../../Redux/actions/actions';
import DriverListItem from './components/list-item.jsx';
import { snack } from '../../../utils/SnackbarUtilsConfigurator';
import Avatar from '../../../design-system/lib/Avatar';
import { get_id } from '../../../helper/UserData/userdate';
import { getCenterMap } from '../../../helper/module';
import Tag from '../../../design-system/lib/Tag';
import CustomField_DropDown from '../../../CustomFields/DropDown';
import Radiobutton from '../../../design-system/lib/Radiobutton';
import Toggle from '../../../design-system/lib/toggle';
import EllipisWithTooltip from '../../../design-system/lib/ellipsis-with-tooltip';
import CustomField_Input from '../../../CustomFields/Input';
import Checkbox from '../../../design-system/lib/Checkbox';
import { isEmpty } from 'lodash';



function DriverNewOrder() {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = React.useState(0);
  const mapRef = useSelector((state) => state.Map.mapRef)

  const auto = useSelector((state) => state.NewOrder.newOrder.driver.auto)
  const auto_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_activeVehicleType)
  const auto_suggestListLoading = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListLoading)
  const auto_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListData)
  const auto_suggestListOrdered = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListOrdered)
  const manual_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_activeVehicleType)
  const manual_name = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_name)
  const manual_rate = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.rate)

  const manual_code = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_code)
  const manual_family = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_family)
  const manual_id = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_id)
  const manual_suggestListLoading = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_suggestListLoading)
  const manual_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_suggestListData)
  const manual_suggestListOrdered = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_suggestListOrdered)
  const lang = useSelector((state) => state.LocalData.lang)
  const searchDriverInput = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.searchDriverInput)
  const forceAssaigning = useSelector((state) => state.NewOrder.newOrder.driver.forceAssaigning)
  const sendOrder = useSelector((state) => state.NewOrder.newOrder.sendOrder)
  const customer = useSelector((state) => state.NewOrder.newOrder.customer)
  const options = useSelector((state) => state.NewOrder.newOrder.driver.options)
  const manual_number = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_number)
  const driverAllvehicletypes = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.driverAllvehicletypes)
  const activeService = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const manual_vehicleTypes = useSelector((state) => state.NewOrder.newOrder.driver.manual_driver.manual_vehicleTypes)
  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const ManualEta_active = useSelector((state) => state.NewOrder.newOrder.driver.ManualEta.active)
  const ManualEta_value = useSelector((state) => state.NewOrder.newOrder.driver.ManualEta.num)
  const etaSetting = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType?.etaSetting?.Pending?.isActive)

  const [collapsed, setCollapsed] = React.useState(true);


  const dispatch = useDispatch();



  React.useEffect(() => {


    if (activeService && manual_id != "" && manual_id != null) {
      FindLocalVehicletype(
        manual_vehicleTypes,
        auto_suggestListData,
        (call) => {
          if (call.length > 0) {


            let activeVehicleType = null;

            if (manual_activeVehicleType) {
              let currentVehicleIsOk = call.find((element) => element.id == manual_activeVehicleType.id);;

              activeVehicleType = currentVehicleIsOk ? manual_activeVehicleType : call[0];
            } else {
              if (call.length != 0) {
                activeVehicleType = call[0];
              } else {
                snack.warning_i18("DriverVehicleTypeError")
              }
            }

            activeVehicleType &&
              dispatch(
                Set_Manual_ActiveVehicleType({

                  manual_activeVehicleType: activeVehicleType,
                  driverAllvehicletypes: call,
                })
              );


          } else {
            dispatch(
              Set_Manual_ActiveVehicleType({
                manual_activeVehicleType: null,
                driverAllvehicletypes: []
              })
            );
          }
        }
      );
    }



  }, [auto_suggestListData, manual_vehicleTypes, activeService, manual_id])

  const handleAutoVehicleTypeSelect = (service) => {
    dispatch(Set_Auto_ActiveVehicleType(service));
  };

  const SelectableItemHandleactive = (OP) => {
    if (SelectableItemOptionisSaved(OP)) {
      dispatch(Remove_Driver_Option(OP.id))
    } else {
      dispatch(Add_Driver_Option({
        name: OP.name,
        id: OP.id,
        type: "boolean"
      }))
    }

  };


  const SelectableItemOptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }

  const listHandleSelectedItem = (item, OP) => {
    dispatch(Remove_Driver_Option(OP.id))

    dispatch(Add_Driver_Option({
      name: OP.name,
      id: OP.id,
      item,
      type: "list"
    }))
  };

  const listOptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }

  const listOptionText = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return booll.item.title
    } else {
      return false
    }
  }

  const handleAutoManual = (inde) => {
    if (inde == 0 || inde == 1) {
      // dispatch(Update_Driver_ManualEta({key :"active" , value : false})  )
      dispatch(Set_Auto_Driver(inde == 1 ? false : true));
      setActiveIndex(inde)
    } else {
      // dispatch(Update_Driver_ManualEta({key :"active" , value : false})  )
      setActiveIndex(inde)
      dispatch(Set_Auto_Driver(null));

    }
  };

  const FindLocalVehicletype = (driverVehicletypes, localservives, call) => {
    let vehicletype = [];

    driverVehicletypes?.forEach((element) => {
      localservives.forEach((localservive) => {
        if (element == localservive.id) {
          vehicletype.push(localservive);
        }
      });
    });

    call(vehicletype);


  };

  const SearchDriver = React.useCallback((input, manual) => {

    dispatch(
      SearchDriverAction(dispatch, {
        searchRegex: input ? input : searchDriverInput,
        vehicleTypes: manual ? manual.id : (manual_activeVehicleType ? manual_activeVehicleType.id : ""),
      })
    );

  }, [searchDriverInput, manual_activeVehicleType]);

  const InputOnChange = (e) => {

    if (e) {
      dispatch(
        Set_Manual_ActiveVehicleType({
          manual_code: e.target.value,
          manual_id: null,
          searchDriverInput: e.target.value,
          driverAllvehicletypes: [],
        })
      );
    }




    e && SearchDriver(e.target.value)

  };

  const handleSelectedItem = (item) => {
    dispatch(
      Set_Manual_ActiveVehicleType({
        manual_activeVehicleType: item,
      })
    );

    SearchDriver(null, item)

  };


  const handleSelectDriverVehicle = (item) => {
    dispatch(
      Set_Manual_ActiveVehicleType({
        manual_activeVehicleType: item,
      })
    );
  };

  const handleManualVehicleTypeSelect = (service) => {

    FindLocalVehicletype(
      service.vehicleTypes,
      auto_suggestListData,
      (call) => {
        if (call) {
          let activeVehicleType = null;

          if (manual_activeVehicleType) {
            activeVehicleType = manual_activeVehicleType;
          } else {
            if (call.length != 0) {
              activeVehicleType = call[0];
            } else {
              snack.warning_i18("DriverVehicleTypeError")
            }
          }

          activeVehicleType &&
            dispatch(
              Set_Manual_ActiveVehicleType({

                manual_activeVehicleType: activeVehicleType,
                driverAllvehicletypes: call,
                manual_name: service.name,
                manual_family: "",
                manual_number: service.phone,
                manual_id: service.id,
                manual_code: service.username,
                rate: service.rate,
                manual_vehicleTypes: service.vehicleTypes
              })
            );
        }
      }
    );

  }


  const makeOutgoingCall = () => {
    dispatch(Voip_OutgoingCall(dispatch, {
      "to": manual_number,
      "orderId": null,
      "customerId": null,
      "driverId": manual_id,
      "dispatcherId": get_id()
    }))
  }

  const resetDriver = React.useCallback(() => {

    if (auto_suggestListData && auto_suggestListData.length > 0) {
      dispatch(Set_Auto_ActiveVehicleType(auto_suggestListData[0]))
    }
    dispatch(
      Set_Manual_ActiveVehicleType({
        driverAllvehicletypes: [],
        searchDriverInput: "",
        manual_activeVehicleType: null,
        manual_name: "",
        manual_family: "",
        manual_number: "",
        manual_id: "",
        manual_code: "",
      })
    );

    dispatch(Set_Auto_Driver(false));
    setActiveIndex(1)

  }, [auto_suggestListData]);


  const handleForceAssaigning = () => {
    dispatch(Set_Force_Assaigning(!forceAssaigning));
    dispatch(Update_Driver_ManualEta({key :"active" , value : !forceAssaigning ? false : false})  )
   dispatch(Update_Driver_ManualEta({key :"num" , value :  ""})  )

    
  };



  const Buttonhandleactive = (OP) => {
    if (ButtonoptionisSaved(OP)) {
      dispatch(Remove_Driver_Option(OP.id))
    } else {
      dispatch(Add_Driver_Option({
        name: OP.name,
        id: OP.id,
        type: "boolean"
      }))
    }

  };


  const ButtonoptionisSaved = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }


  const DrophandleSelectedItem = (OP, item) => {
    console.log("DrophandleSelectedItem", OP, item)
    dispatch(Remove_Driver_Option(OP.id))

    dispatch(Add_Driver_Option({
      name: OP.name,
      id: OP.id,
      item,
      type: "list"
    }))

  };


  const DropoptionisSave = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return true
    } else {
      return false
    }
  }

  const DropoptionText = (OP) => {
    let booll = false;
    booll = options.find((item) => {
      return item.id === OP.id;
    });
    if (booll) {
      return booll.item.title
    } else {
      return false
    }
  }


  React.useEffect(() => {

    if (!manual_activeVehicleType) {
      dispatch(Set_Auto_Driver(true));
      setActiveIndex(0)
    }



  }, [])


  function ItemsList(data, currentState, setCurrentState) {
    console.log("ItemsList ", data, currentState, setCurrentState)

    return (
      <div className={styles.itemsConatiner}>
        {data.map((item) => {
          return <div onClick={() => { setCurrentState(item) }}>
            <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
            {item.icon && <img src={item.icon} />}
            <Typography weight={currentState == (currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={currentState == (currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

          </div>
        })}
      </div>
    )
  }

    function ItemsListOld(data, currentState, setCurrentState) {
     return (
        <div className={styles.itemsConatinerOld}>
            {data.map((item) => {
                return <div onClick={() => { setCurrentState(item) }}>
                    <img src={item.icon} />
                    <span style={{display:"flex",flexDirection:"column",gap:"1px",width:"calc(100% - 20px)"}}>
                      <Typography weight={currentState == item.title ? 'Body_Middle_Bold' :'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={styles.dropItem} />
                      <Typography weight={ 'Body_Tiny_Regular'} textColor={'TextLight'} text={item.description} className={styles.dropItem} style={{textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} />
                    </span>
                </div>
            })}
        </div>
    )
}




  if (manual_id != "" && manual_id != null) {
    return <div className={styles.DriverNewOrderContainer} >
      <div className={styles.selectedUserContainer}>

        <div className={styles.avatarContainer}>
          <Avatar type='customer' style={{ width: "36px", height: "36px" }} />
          <span className={styles.IconProvider}><IconProvider Icon={STAR} size='12' style={{ width: "10px" }} /> {manual_rate}</span>
          {/* <IconProvider Icon={type == "business" ? GROUP_1925 : CUSTOMER_TYPE} className={styles.IconProvider} size='16' /> */}
        </div>

        <div className={styles.nameUsernameContainer}>
          <Typography weight='Body_Middle_Medium' text={manual_name} style={{fontSize:"13px"}} />
          <Typography weight='Subtitle_Tiny_Regular' text={<><img src={adsigne} /> {manual_code}</>} style={{display:"flex",flexDirection:"row" , gap:"2px",justifyContent:"center",alignItems:"center",fontSize:"13px"}} />
        </div>


        {!manual_activeVehicleType && <div className={styles.forceVehicleContainer}> <Tag size='Small' weight='Body_Tiny_Regular' text={t("DriverVehicleTypeError")} backgroundColor='RedUltraLight' color='TextDark' /></div>}

        {/* <Tag size='Large' text={`${getSymbolFromCurrency(get_currencyCode())}${balance}`} backgroundColor='GrayUltraLight' color='TextDark' icon={WALLET} style={{ marginInlineStart: "16px", marginInlineEnd: "auto" }} iconSize='16' /> */}

        {global.config.dispatcherSettings.isVoipActvie && <Button size={'Small'} type='Secondary' icon={CALL} style={{ marginInlineStart: "auto" , padding :"5px" }} onClick={makeOutgoingCall} />}


        {/* <IconProvider Icon={CLOSE_DARK} size='16' style={{ marginInlineStart: "12px", cursor: "pointer" ,alignSelf:"start",marginTop:"8px"}} onClick={resetDriver} /> */}
        <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: global.config.dispatcherSettings.isVoipActvie ? "8px" : "auto", backgroundColor: "transparent", padding: "5px" }} onClick={resetDriver} />


      </div>
      {manual_activeVehicleType && <div className={styles.forceVehicleContainer} style={{ marginBottom: (manual_activeVehicleType && manual_activeVehicleType.options.length > 0) ? "0px" : "", width: "100%" }}>
        <DropDown size='Small' icon={manual_activeVehicleType?.icon} text={manual_activeVehicleType?.title} placement='bottomStart' data={driverAllvehicletypes} onClick={(JOJO) => { handleSelectDriverVehicle(JOJO) }} style={{ flex: '1' }} />
        {/* <Button size={'Small'} type='Secondary' text={t("ForceAssign")} onClick={handleForceAssaigning} isActive={forceAssaigning} /> */}

        <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={false} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />

      </div>}

      {collapsed && <div className={styles.collapsed} >

          {(orderTypeActive == "Ondemand" && etaSetting && !forceAssaigning) && <div className={styles.OptionsRow}>
            <span style={{cursor:"pointer",userSelect:"none",
              fontSize: '13px', height: "23.3px", alignItems: "center", display: "flex", fontWeight: '400', color: "rgba(72, 72, 72, 1)",
              marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "start", alignItems: "center"
            }}> 
            {/* <Checkbox size='Small' state={ManualEta_active ? 'checked' : "unchecked"} style={{ marginInlineEnd: "3px", cursor: "pointer" }} /> */}
             {t("Override ETA")}

            </span>
            <CustomField_Input config={{
              "type": "number"
            }} icon={hashtag2} hint={t("Enter in mintues")} defvalue={ManualEta_value} inputType="text" onChange={(e) => {
              //            handlePickUpInputs(e, "noteForDriver")
              dispatch(Update_Driver_ManualEta({key :"num" , value :  e})  )
              dispatch(Update_Driver_ManualEta({key :"active" , value : isEmpty(e) ? false : true})  )

            }} /> 
          </div>
          
          }


        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> {t("ForceAssign")}  </span>
          <Toggle isActive={forceAssaigning} setIsHover={handleForceAssaigning} />
        </div>

        {(manual_activeVehicleType && manual_activeVehicleType.options.length > 0) && <div className={styles.titleOptionsRow} >
          <Typography text={t("Options")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />

        </div>}

        {(manual_activeVehicleType && manual_activeVehicleType.options.length > 0) && < >
          {manual_activeVehicleType.options.map((item) => {
            return item.type === "list" ? (

              <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none",   whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1"}}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden" ,display:"flex" ,flexDirection:"row" }}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip> </span>   {(item.isRequired && !DropoptionisSave(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                <CustomField_DropDown icon={list_gray} ItemsList={ItemsList(item.data.map((item) => { return { ...item } }), DropoptionisSave(item) ? DropoptionText(item) : item.title, (JOJO) => DrophandleSelectedItem(item, JOJO))} textStyle={styles.DropDownTextStyle} size='Small' text={DropoptionisSave(item) ? DropoptionText(item) : t("Select")} placement={'bottomStart'} data={item.data} requiredText={t("Required")} onClick={(JOJO) => DrophandleSelectedItem(item, JOJO)} isSelected={DropoptionisSave(item)} clearText={t("clear")} clearOnClick={() => { DropoptionisSave(item) && dispatch(Remove_Driver_Option(item.id)) }} />
              </div>

              // <DropDown size='Small' text={DropoptionisSave(item) ? DropoptionText(item) : item.title} placement='bottomStart' data={item.data} isRequired={DropoptionisSave(item) ? false : item.isRequired} requiredText={t("Required")} onClick={(JOJO) => DrophandleSelectedItem(item, JOJO)} isSelected={DropoptionisSave(item)} clearText={t("clear")} clearOnClick={() => { DropoptionisSave(item) && dispatch(Remove_Driver_Option(item.id)) }} />
            ) :
              <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1" ,display:"flex" ,flexDirection:"row" }}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden"}}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip> </span>   {(item.isRequired && !ButtonoptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                <Toggle isActive={ButtonoptionisSaved(item)} setIsHover={() => { Buttonhandleactive(item) }} />
              </div>
          })}


        </ >}


      </div>}

      {/* {(manual_activeVehicleType && manual_activeVehicleType.options.length > 0) && <div className={styles.ServiceNewOrderSecondRow2}>
        {manual_activeVehicleType.options.map((item) => {
          return item.type === "list" ? (
            <DropDown size='Small' text={DropoptionisSave(item) ? DropoptionText(item) : item.title} placement='bottomStart' data={item.data} isRequired={DropoptionisSave(item) ? false : item.isRequired} requiredText={t("Required")} onClick={(JOJO) => DrophandleSelectedItem(item, JOJO)} isSelected={DropoptionisSave(item)} clearText={t("clear")} clearOnClick={() => { DropoptionisSave(item) && dispatch(Remove_Driver_Option(item.id)) }} />
          ) : <Button size={'Small'} type='Secondary' isRequired={item.isRequired} requiredText={t("Required")} text={item.title} isActive={ButtonoptionisSaved(item)} onClick={() => { Buttonhandleactive(item) }} />
        })}
 

      </div>} */}
    </div>

  }





  return (
    <div className={styles.DriverNewOrderContainer}  >
      <div className={styles.DriverTitleContainer}>
        <IconProvider Icon={DRIVER_1} size="16" />
        <Typography weight='Body_Middle_Bold' text={t("driver")} style={{marginInlineEnd:'4px',fontSize:"13px" , fontWeight:"600"}} />
        <Switch items={[t("Auto"), t("Manual"), t("statusUnassigned")]} index={activeIndex} handleSelection={handleAutoManual} />
      </div>

      {(activeIndex == 0 && (manual_id == "" ||
        manual_id == null)) && <>

        <div className={styles.forceVehicleContainer} style={{ width: "100%" }}>
          <DropDown ItemsList={ItemsListOld(auto_suggestListData, auto_activeVehicleType?.title, handleAutoVehicleTypeSelect)} size='Medium' text={auto_suggestListData?.length > 0 ? (auto_activeVehicleType?.title ? auto_activeVehicleType?.title : t("pleaseSellectParsel")) : t("pleaseSellectParsel")}
            icon={auto_suggestListData?.length > 0 && auto_activeVehicleType?.icon} placement='bottomEnd' data={auto_suggestListData} onClick={handleAutoVehicleTypeSelect} style={{ flex: "1", maxWidth: "calc(100% - 12px)" }} />

          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0 || (orderTypeActive == "Ondemand")) && <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={false} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />}

        </div>

        {(collapsed && (auto_activeVehicleType && auto_activeVehicleType.options.length > 0 || (orderTypeActive == "Ondemand"))) && <div className={styles.collapsed} >

          {(orderTypeActive == "Ondemand" && etaSetting) && <div className={styles.OptionsRow}>
            <span  style={{ cursor:"pointer",userSelect:"none",
              fontSize: '13px', height: "23.3px", alignItems: "center", display: "flex", fontWeight: '400', color: "rgba(72, 72, 72, 1)",
              marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "start", alignItems: "center"
            }}> 
            {/* <Checkbox size='Small' state={ManualEta_active ? 'checked' : "unchecked"} style={{ marginInlineEnd: "3px", cursor: "pointer" }} />  */}
            {t("Override ETA")}

            </span>
            <CustomField_Input config={{
              "type": "number"
            }} icon={hashtag2} hint={t("Enter in mintues")} defvalue={ManualEta_value} inputType="text" onChange={(e) => {
              //            handlePickUpInputs(e, "noteForDriver")
              dispatch(Update_Driver_ManualEta({key :"num" , value :  e})  )
              dispatch(Update_Driver_ManualEta({key :"active" , value : isEmpty(e) ? false : true})  )

            }} /> 
          </div>
          
          }

          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0) && <div className={styles.titleOptionsRow} >
            <Typography text={t("Options")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
            <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />

          </div>}

          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0) && < >
            {auto_activeVehicleType.options.map((item) => {
              return item.type === "list" ? (

                <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1"}}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden" ,display:"flex" ,flexDirection:"row"}}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip></span>   {(item.isRequired && !listOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <CustomField_DropDown icon={list_gray} ItemsList={ItemsList(item.data.map((item) => { return { ...item } }), listOptionisSaved(item) ? listOptionText(item) : item.title, (JOJO) => listHandleSelectedItem(JOJO, item))} textStyle={styles.DropDownTextStyle} size='Small' text={listOptionisSaved(item) ? listOptionText(item) : t("Select")} placement={'bottomStart'} data={item.data} requiredText={t("Required")} onClick={(JOJO) => listHandleSelectedItem(item, JOJO)} isSelected={listOptionisSaved(item)} clearText={t("clear")} clearOnClick={() => {listOptionisSaved(item) && dispatch(Remove_Driver_Option(item.id))  }} />
                </div>

               ) :
                <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1"}}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden" ,display:"flex" ,flexDirection:"row"}}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip></span>   {(item.isRequired && !SelectableItemOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <Toggle isActive={SelectableItemOptionisSaved(item)} setIsHover={() => { SelectableItemHandleactive(item) }} />
                </div>
            })}


          </ >}


        </div>}

 
          {/* {(auto_activeVehicleType && auto_activeVehicleType?.options.length > 0) && <div className={styles.ServiceNewOrderSecondRow}>
            {auto_activeVehicleType?.options.map((item, i) => {
              return item.type === "list" ? (
                <DropDown size='Small' text={listOptionisSaved(item) ? listOptionText(item) : item.title} placement={i == 0 ? 'bottomStart' : "bottomEnd"} data={item.data} isRequired={listOptionisSaved(item) ? false : item.isRequired} requiredText={t("Required")} onClick={(JOJO) => listHandleSelectedItem(JOJO, item)} isSelected={listOptionisSaved(item)} clearText={t("clear")} clearOnClick={() => { listOptionisSaved(item) && dispatch(Remove_Driver_Option(item.id)) }} />
              ) : <Button size={'Small'} type='Secondary' isRequired={item.isRequired} requiredText={t("Required")} text={item.title} isActive={SelectableItemOptionisSaved(item)} onClick={() => { SelectableItemHandleactive(item) }} />
            })}
         

          </div>} */}

        </>

      }


      {(activeIndex == 1 && (manual_id == "" ||
        manual_id == null)) && <>

          <SearchList style={{ zIndex: "3" ,marginBottom:"-4.5px" }} placeHolder={t("CodeNameFamilyPhonenumber")} onChange={InputOnChange} value={searchDriverInput}
            isloading={manual_suggestListLoading}
            errorIcon={DRIVER_COLOR}
            errorActionOnClick={() => {
              dispatch(
                Set_Manual_ActiveVehicleType({
                  manual_code: "",
                  manual_id: null,
                  searchDriverInput: "",
                  driverAllvehicletypes: [],
                  manual_suggestListData: [],
                  manual_suggestListOrdered: false,
                })
              );
            }}
             listItemOnclick={handleManualVehicleTypeSelect}
            list={(manual_suggestListOrdered && String(searchDriverInput).length > 0) ? (manual_suggestListData.length > 0 ? manual_suggestListData : null) : null}
            error={!manual_suggestListLoading && manual_suggestListOrdered && manual_suggestListData.length === 0 && String(searchDriverInput).length > 0} errorTitle={t("NoDriverfound")} errorDescription={t("NoDriverfoundDesc")} errorActionTitle={t("ClearField")}
            ListItemChildren={DriverListItem} inputInnerChildren={<DropDown className={styles.DropDown} ItemsList={ItemsListOld([{ icon: Success_list, title: t("Allvehicletypes"), description: t("Allvehicletypes") }, ...auto_suggestListData], manual_activeVehicleType?.title, handleSelectedItem)} size='Small' placement='bottomEnd' text={manual_activeVehicleType ? manual_activeVehicleType.title : t("Allvehicletypes")} data={auto_suggestListData} onClick={handleSelectedItem} />}
          />
  {(orderTypeActive == "Ondemand" && etaSetting ) && <div className={styles.OptionsRow}>
            <span   style={{cursor:"pointer",userSelect:"none",
              fontSize: '13px', height: "23.3px", alignItems: "center", display: "flex", fontWeight: '400', color: "rgba(72, 72, 72, 1)",
              marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex",
              flexDirection: "row", justifyContent: "start", alignItems: "center"
            }}> 
            {/* <Checkbox size='Small' state={ManualEta_active ? 'checked' : "unchecked"} style={{ marginInlineEnd: "3px", cursor: "pointer" }} /> */}
             {t("Override ETA")}

            </span>
            <CustomField_Input config={{
              "type": "number"
            }} icon={hashtag2} hint={t("Enter in mintues")} defvalue={ManualEta_value} inputType="text" onChange={(e) => {
              //            handlePickUpInputs(e, "noteForDriver")
              dispatch(Update_Driver_ManualEta({key :"num" , value :  e})  )
              dispatch(Update_Driver_ManualEta({key :"active" , value : isEmpty(e) ? false : true})  )

            }} /> 
          </div>
          
          }

        </>

      }

      {(activeIndex == 2 && (manual_id == "" ||
        manual_id == null)) && <>
              <div className={styles.forceVehicleContainer} style={{  width: "100%" }}>
          <DropDown ItemsList={ItemsListOld(auto_suggestListData, auto_activeVehicleType?.title, handleAutoVehicleTypeSelect)} size='Medium' text={auto_suggestListData?.length > 0 ? (auto_activeVehicleType?.title ? auto_activeVehicleType?.title : t("pleaseSellectParsel")) : t("pleaseSellectParsel")}
            icon={auto_suggestListData?.length > 0 && auto_activeVehicleType?.icon} placement='bottomEnd' data={auto_suggestListData} onClick={handleAutoVehicleTypeSelect} style={{ flex:"1", maxWidth: "calc(100% - 12px)" }} />

          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0) &&  <Button className={!collapsed && styles.arrowDown} icon={double_top} size={'Medium'} type='Secondary' requiredText='*' isRequired={false} onClick={() => { setCollapsed(!collapsed) }} style={{ paddingInlineStart: "auto", paddingInlineEnd: "auto", padding: "7px", width: "14px", height: "14px" }} />}

      </div>

        {(collapsed && (auto_activeVehicleType && auto_activeVehicleType.options.length > 0)) && <div className={styles.collapsed} >



          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0) && <div className={styles.titleOptionsRow} >
            <Typography text={t("Options")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
            <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />

          </div>}

          {(auto_activeVehicleType && auto_activeVehicleType.options.length > 0) && < >
            {auto_activeVehicleType.options.map((item) => {
              return item.type === "list" ? (

                <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1"}}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden" ,display:"flex" ,flexDirection:"row"}}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip></span>   {(item.isRequired && !listOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <CustomField_DropDown icon={list_gray} ItemsList={ItemsList(item.data.map((item) => { return { ...item } }), listOptionisSaved(item) ? listOptionText(item) : item.title, (JOJO) => listHandleSelectedItem(JOJO, item))} textStyle={styles.DropDownTextStyle} size='Small' text={listOptionisSaved(item) ? listOptionText(item) : t("Select")} placement={'bottomStart'} data={item.data} requiredText={t("Required")} onClick={(JOJO) => listHandleSelectedItem(item, JOJO)} isSelected={listOptionisSaved(item)} clearText={t("clear")} clearOnClick={() => {listOptionisSaved(item) && dispatch(Remove_Driver_Option(item.id))  }} />
                </div>

               ) :
                <div className={styles.OptionsRow}>
                  <span style={{fontSize: '13px', fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", flex: "1"}}> <span style={{textDecoration:"none",textOverflow:"ellipsis",whiteSpace:"nowrap",overflow:"hidden" ,display:"flex" ,flexDirection:"row"}}> <EllipisWithTooltip>{item.title}</EllipisWithTooltip></span>   {(item.isRequired && !SelectableItemOptionisSaved(item)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
                  <Toggle isActive={SelectableItemOptionisSaved(item)} setIsHover={() => { SelectableItemHandleactive(item) }} />
                </div>
            })}


          </ >}


        </div>}

        </>

      }

    </div>
  )
}

export default DriverNewOrder